import 'rxjs'
import {ajax} from 'rxjs/observable/dom/ajax'
import config from '../config'
import {buildUserInfoPayload} from './CurrentUserInfoEpic'
import errorHandlerBuilder from './errorHandlerBuilder'
import {
  ACTION_UPDATE_USER_INFO_ERROR,
  ACTION_UPDATE_USER_INFO_LOADED,
  ACTION_UPDATE_USER_INFO_LOADING,
  EVENT_USER_UPDATED,
  PATH_USER,
} from '../constants'

const api_server_host = config.api_server_host

const errorHandler = errorHandlerBuilder(ACTION_UPDATE_USER_INFO_ERROR)

const epic = (action$, store) =>
  action$.ofType(ACTION_UPDATE_USER_INFO_LOADING)
    .mergeMap(action => {

      const tokenData = store.getState().user
      const token = tokenData.access_token
      const type = tokenData.token_type

      return ajax({
        method: 'POST',
        url: `${api_server_host}${PATH_USER}/${action.payload.id}`,
        headers: {
          Authorization: `${type} ${token}`,
          'Content-Type': 'application/json'
        },
        body: action.payload,
        responseType: 'json'
      }).map(data=> {
        const userInfo = data.response
        var payload = buildUserInfoPayload(userInfo)
        payload.message = 'Update Successful'
        return {
          type: ACTION_UPDATE_USER_INFO_LOADED, payload: payload
        }
      }).rxEmit(EVENT_USER_UPDATED).catch(errorHandler)

    })
export default epic




// WEBPACK FOOTER //
// ./src/epics/UpdateUserInfoEpic.js